var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronsLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7254 7.02817C12.0915 7.44659 12.0915 8.12498 11.7254 8.5434L7.70082 13.1429L11.7254 17.7425C12.0915 18.1609 12.0915 18.8393 11.7254 19.2577C11.3593 19.6761 10.7657 19.6761 10.3996 19.2577L5.71209 13.9005C5.34597 13.4821 5.34597 12.8037 5.71209 12.3853L10.3996 7.02817C10.7657 6.60975 11.3593 6.60975 11.7254 7.02817Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2879 7.02817C18.654 7.44659 18.654 8.12498 18.2879 8.5434L14.2633 13.1429L18.2879 17.7425C18.654 18.1609 18.654 18.8393 18.2879 19.2577C17.9218 19.6761 17.3282 19.6761 16.9621 19.2577L12.2746 13.9005C11.9085 13.4821 11.9085 12.8037 12.2746 12.3853L16.9621 7.02817C17.3282 6.60975 17.9218 6.60975 18.2879 7.02817Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronsLeft);
export default __webpack_public_path__ + "static/media/chevrons-left.27daceedf5bde8b81c9b345e3d9baaac.svg";
export { ForwardRef as ReactComponent };